import type { Location, InternalLocationParser } from './location-select.types';

type ParsedLocation = { lat: number; lng: number };

export const parseLocation: InternalLocationParser = (
	result,
): ParsedLocation => {
	// eslint-disable-next-line @typescript-eslint/unbound-method
	const { lat = 0, lng = 0 }: google.maps.LatLng | Partial<ParsedLocation> =
		result.geometry?.location ?? {};

	return {
		lat: typeof lat === 'number' ? lat : lat(),
		lng: typeof lng === 'number' ? lng : lng(),
	};
};

const getCity = (
	addressComponent: google.maps.GeocoderAddressComponent,
): string => {
	const { types } = addressComponent;

	if (
		!types.includes('locality') &&
		!types.includes('sublocality') &&
		!types.includes('administrative_area_level_3')
	) {
		return '';
	}

	return addressComponent.long_name;
};

export const parseAddress: InternalLocationParser = (result): Location => {
	const addressComponents = result.address_components ?? [];

	let city = '';
	let state = '';
	let country = '';
	let zipcode = '';
	let county = '';
	let streetNumber = '';
	let streetName = '';

	for (const addressComponent of addressComponents) {
		const { types } = addressComponent;

		city = city || getCity(addressComponent);

		if (types.includes('administrative_area_level_1')) {
			state = addressComponent.short_name;
		}

		if (types.includes('country')) {
			country = addressComponent.short_name;
		}

		if (types.includes('postal_code')) {
			zipcode = addressComponent.short_name;
		}

		if (types.includes('administrative_area_level_2')) {
			county = addressComponent.short_name;
		}

		if (types.includes('street_number')) {
			streetNumber = addressComponent.short_name;
		}

		if (types.includes('route')) {
			streetName = addressComponent.short_name;
		}
	}

	return {
		city,
		state,
		country,
		zipcode,
		county,
		streetNumber,
		streetName,
		address: result.formatted_address,
	};
};

export const DEFAULT_PARSERS: InternalLocationParser[] = [
	parseAddress,
	parseLocation,
];
